const svgBaseClasses = 'h-12 w-12 text-white';

export default svgBaseClasses;
